/**
 * Class default object
 * _modelPath : source 3D - string
 * _id : id - string
 * _position : position of object - Vector3
 * _scale : size of object (for window for example) : [x,y]
 * _collision : accect collision with other objects : Boolean
 * _axesMove : axes move object : [true, true, true] // x,y,z
 */
import * as THREE from "three";
import Experience from "../../Experience.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

export default class CustomObject {
  constructor(_modelPath, _id, _position, _rotation, options = {}) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.renderer = this.experience.renderer;
    this.camera = this.experience.camera;
    this.sizes = this.experience.sizes;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.objectManager = this.experience.objectManager;
    this.interactionManager = this.experience.room.interactionManager;

    this.scale = options.scale || new THREE.Vector3(1, 1, 1);

    /*  this.objectsControl = this.experience.room.objectsControl; */

    this.raycaster = this.experience.raycaster;
    this.gltfLoader = new GLTFLoader();

    // Propriété
    this.modelPath = _modelPath;
    this.id = _id;
    this.position = _position || new THREE.Vector3(0, 0, 0);
    this.rotation = _rotation || new THREE.Euler(0, 0, 0);

    // Resource
    this.model = new THREE.Object3D();
    this.resource = this.resources.items.objectModel;

    this.createModel();
  }

  /**
   * Create model
   */
  createModel() {
    this.gltfLoader.load(this.modelPath, (gltf) => {
      this.model = gltf.scene;
      this.model.scale.copy(this.scale);
      this.model.oldPosition = this.model.position.clone();
      this.model.userData.id = this.id;
      this.model.userData.type = this.type;
      this.model.name = this.type;
      this.model.userData.scale = this.scale;

      /* if(this.rotation) {
        this.model.rotation.set(this.rotation[0],this.rotation[1],this.rotation[2]);
      } */

      // for showerWall
      if (this.subType) {
        this.model.userData.subType = this.subType;
      }
      if (this.aimantee) {
        this.model.userData.aimantee = this.aimantee;
      }

      if (this.rideauLeste) {
        this.model.userData.rideauLeste = this.rideauLeste;
      }

      // for showerTray
      if (this.pn) {
        this.model.userData.pn = this.pn;
      }

      this.model.userData.src = this.modelPath;
      this.model.userData.collision = this.collisionAllowed;
      this.model.userData.snapping = this.snappingAllowed;
      this.model.userData.axesMove = this.axesMove;

      if (this.shadow !== false) {
        this.model.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            child.material.side = THREE.DoubleSide;
          }
        });
      }

      if (this.windowLight) {
        if (this.position.y === 0) {
          this.position.y = 0.5;
        }

        const group = new THREE.Group();
        group.name = "windowGroup";

        /* this.windowLight.position.y = this.position.y ; */

        /*    this.windowLight.position.y = this.scale.y / 2;
        this.windowLight.rotation.copy(this.rotation);
        this.windowLight.position.z = this.model.position.z + 0.02; */

        group.add(this.model);
        group.add(this.windowLight);

        const box = new THREE.Box3().setFromObject(this.model);
        const boxSize = new THREE.Vector3();
        box.getSize(boxSize);

        const offsetY = boxSize.y / 2;

        // Ajuste la position relative
        this.windowLight.position.y = offsetY;

        group.position.copy(this.position);

        if (this.rotation) {
          group.rotation.copy(this.rotation);
        }
        /*      this.windowLight.position.y = this.position.y ;
        this.windowLight.position.z = this.position.y + 0.02; */

        this.objectManager.addObject(group);
        this.objectManager.addObjectCollision(group);
        this.scene.add(group);
      } else {
        this.model.position.copy(this.position);
        if (this.rotation) {
          this.model.rotation.copy(this.rotation);
        }

        this.objectManager.addObject(this.model);
        this.objectManager.addObjectCollision(this.model);
        this.scene.add(this.model);
      }
    });
  }

  /**
   * Set existant model
   */
  setModel(options = {}) {
    if (!this.model) {
      console.error(
        "Aucun modèle existant à mettre à jour. Utilisez `createModel` d'abord."
      );
      return;
    }

    // If path of model change
    if (options.modelPath && options.modelPath !== this.modelPath) {
      this.modelPath = options.modelPath;

      // Load new model
      this.gltfLoader.load(this.modelPath, (gltf) => {
        const newModel = gltf.scene;

        // Replace childs of existing model
        while (this.model.children.length) {
          this.model.remove(this.model.children[0]);
        }

        newModel.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            child.material.side = THREE.DoubleSide;
          }
        });

        // Add new childs
        this.model.add(...newModel.children);

        // Updates object properties
        /* if(options.scale ) {
          this.model.scale.copy(this.scale);
        } */
        this.model.position.copy(options.position || this.model.position);

        // Update userData
        if (options.userData) {
          Object.assign(this.model.userData, options.userData);
        }

        // Update others properties
        if (options.collisionAllowed !== undefined) {
          this.model.userData.collision = options.collisionAllowed;
        }
        if (options.snappingAllowed !== undefined) {
          this.model.userData.snapping = options.snappingAllowed;
        }

        console.log("id : ");

        console.log(options.id);
        this.model.userData.src = this.modelPath;
        this.model.userData.id = options.id;

        /**
         * Contraintes meubles (colonnes axes autorisés différents)
         */
        if (this.model.userData.type === "furniture") {
          if (
            this.model.userData.id === "6632300-B" ||
            this.model.userData.id === "3700970"
          ) {
            this.model.userData.axesMove = [true, true, true];
          } else {
            this.model.position.y = 0;
            this.model.userData.axesMove = [true, false, true];
          }
          if (this.interactionManager) {
            this.interactionManager.setAxiesTransformControl();
          }
        }

        console.log("Modèle remplacé avec succès !");
      });
    } else {
      console.warn(
        "Le chemin du modèle est identique. Aucune action nécessaire."
      );
    }
  }

  /**
   * Set scale of model
   */
  setModelScale(model, scale) {
    model.scale.copy(scale);
  }
}
